export { default as LayoutSwitcherContainer } from './LayoutSwitcherContainer.vue';
